import {getStoreSites, createRedirectsImportJob} from "../api/storefront/storefront";
import {getProductByID, getProductDataBySKUs, updateProductPrice} from "../api/storefront/products";
import {showErrorMessage} from "./AlertMessage";

export async function getAllProductDataBySKUs(linkedSkuList) {
    const products = [];
    if (linkedSkuList.length > 0) {
        // Get all the linked products from store (process in chunks to manage the load to storefront)
        const chunkSize = 100;
        let currentSliceStart = 0;
        let currentSliceEnd = chunkSize;
        while (currentSliceStart < linkedSkuList.length) {
            if (currentSliceEnd > linkedSkuList.length)
                currentSliceEnd = linkedSkuList.length;
            const currentSkuListSlice = linkedSkuList.slice(currentSliceStart, currentSliceEnd);

            // Process data in chunks
            const productsSlice = await getProductDataBySKUs(currentSkuListSlice.join(','));
            products.push(...productsSlice);

            currentSliceStart = currentSliceEnd;
            currentSliceEnd += chunkSize;
        }
    }
    return products;
}

export async function setPrimaryProductPrice(primaryProductId, linkedSkuList) {
    if (linkedSkuList.length > 0) {
        const products = await getAllProductDataBySKUs(linkedSkuList);

        // Find the minimum price of the linked products
        let minPrice = 0;
        products.forEach(product => {
            if (minPrice === 0) {
                minPrice = product.price;
                return;
            }
            if (product.price < minPrice)
                minPrice = product.price;
        });
        // Update the primary product price
        if (minPrice > 0) {
            const result = await updateProductPrice(primaryProductId, minPrice);
            if (result?.error) {
                showErrorMessage('Error', `Failed to update the primary product price to $${minPrice} (minimum price). Please update it manually on your store.`);
                console.error(result.message);
            } else {
                console.log('Updated the primary product with the minimum price: ' + minPrice);
            }
        }
    }
}

export async function redirectURLsToPrimaryProduct(linkedSkuList, primaryProductId, attributes, combinations) {
    // Get all products data of the SKU list
    if (linkedSkuList.length > 0) {
        // Get primary product URL and Visibility
        //TODO: Load primary product URL in UseEffect and set the value to original item for future usage
        const primaryProduct = await getProductByID(primaryProductId);
        if (!primaryProduct.product.is_visible)
            return;

        const primaryURLPath = primaryProduct.product.custom_url.url;
        const products = await getAllProductDataBySKUs(linkedSkuList);
        products.forEach(product => {
            const productCombination = combinations.find(combination => combination.sku === product.sku);
            product.option_values = Object.entries(productCombination)
                .filter(([key]) => key.startsWith('attr_'))
                .sort(([a], [b]) => a.localeCompare(b, undefined, { numeric: true }))
                .map(([, value]) => value)
                .filter(value => value !== null);
        });

        // Get All Sites with id and URL
        const sites = await getStoreSites();
        // For each site, loop the products list and create a CSV list of Redirects
        let csvFileContents = 'Domain,Old Path,Manual URL/Path,Dynamic Target Type,Dynamic Target ID\n';
        // Prepare CSV list
        sites.forEach(site => {
            let csvList = [];
            products.filter(product => product.custom_url.url !== null && product.custom_url.url !== '').forEach(linkedProduct => {
                // Build product specific Redirection URL
                const params = new URLSearchParams();
                attributes.forEach((attribute, index) => {
                    // Convert an attribute name like "Model / Type" to something like "model_type" to make it URL friendly
                    const newAttributeName = attribute.name.toLowerCase().replace(/[^a-z0-9]+/gi, ' ').trim().replace(/\s+/g, '_');
                    params.set(newAttributeName, linkedProduct.option_values[index]);
                });
                const dummyDomain = 'https://example.com';
                const finalURL = new URL(dummyDomain + primaryURLPath);
                finalURL.search = params.toString();
                const encodedURL = finalURL.toString();

                csvList.push({
                    domain: new URL(site.url).hostname,
                    old_path: linkedProduct.custom_url.url,
                    product_query: encodedURL.replace(dummyDomain, '')
                });
            });
            csvFileContents += csvList.map(csvEntry => {return csvEntry.domain + ',' + csvEntry.old_path + ',' + csvEntry.product_query + ',,'}).join('\n') + '\n';
        });
        // Create Redirects Import Job for the above created CSV file contents
        if (csvFileContents.split('\n').length > 1) {
            //console.log('Redirects CSV: ', csvFileContents);
            await createRedirectsImportJob(csvFileContents);
        }
    }
}
